import { forwardRef, memo } from 'react';
import { SvgIcon } from '@material-ui/core';

export const TaboolaAdHeadline = memo(
  forwardRef((props, ref) => {
    return (
      <SvgIcon
        {...props}
        ref={ref}
        viewBox="0 0 115 110"
        data-fill-none
      >
        <mask
          id="mask0_1529_12692"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="115"
          height="110"
        >
          <rect
            width="115"
            height="110"
            rx="8"
            fill="#D9D9D9"
          />
        </mask>
        <g mask="url(#mask0_1529_12692)">
          <rect
            x="-3"
            width="121"
            height="112"
            rx="5.09677"
            fill="#BFCDFF"
          />
          <rect
            x="10.0664"
            y="28.0625"
            width="26.4395"
            height="43.004"
            rx="4.61895"
            fill="white"
            stroke="#1E1E1E"
            strokeWidth="0.955645"
          />
          <rect
            x="18.0176"
            y="30.7703"
            width="11.239"
            height="1.27419"
            rx="0.637097"
            fill="#1E1E1E"
          />
          <rect
            x="19.6228"
            y="38.2561"
            width="57.6573"
            height="50.6492"
            rx="0.796371"
            fill="white"
            stroke="#1E1E1E"
            strokeWidth="0.955645"
          />
          <rect
            x="19.145"
            y="62.625"
            width="58.6129"
            height="1.27419"
            fill="#1E1E1E"
          />
          <rect
            x="19.145"
            y="42.875"
            width="58.6129"
            height="0.955645"
            fill="#1E1E1E"
          />
          <rect
            x="23.6047"
            y="53.0686"
            width="49.0564"
            height="2.54839"
            rx="0.637097"
            fill="#8C8C8C"
          />
          <rect
            x="23.6047"
            y="57.5283"
            width="38.8629"
            height="2.54839"
            rx="0.637097"
            fill="#8C8C8C"
          />
          <rect
            x="31.25"
            y="47.9718"
            width="12.1048"
            height="2.54839"
            rx="0.637097"
            fill="#8C8C8C"
          />
          <circle
            cx="26.1531"
            cy="48.6089"
            r="2.54839"
            fill="#8C8C8C"
          />
          <circle
            cx="68.5201"
            cy="40.6452"
            r="0.955645"
            fill="#FFB700"
          />
          <circle
            cx="71.7056"
            cy="40.6451"
            r="0.955645"
            fill="#FFB700"
          />
          <circle
            cx="74.8909"
            cy="40.6451"
            r="0.955645"
            fill="#FFB700"
          />
          <circle
            cx="52.9113"
            cy="70.9074"
            r="1.91129"
            fill="#0C5CEF"
          />
          <path
            d="M45.4549 70.0025C45.5184 69.9133 45.6509 69.9133 45.7144 70.0025L56.2655 84.831C56.3405 84.9365 56.2651 85.0827 56.1357 85.0827H35.0336C34.9042 85.0827 34.8288 84.9365 34.9038 84.831L45.4549 70.0025Z"
            fill="#DDEBDB"
            stroke="#1E1E1E"
            strokeWidth="0.955645"
          />
          <path
            d="M54.6934 75.0875C54.757 74.9995 54.8881 74.9995 54.9517 75.0875L55.3341 74.8113L54.9517 75.0875L61.9879 84.83C62.064 84.9354 61.9887 85.0826 61.8588 85.0826H47.7863C47.6564 85.0826 47.5811 84.9354 47.6572 84.83L54.6934 75.0875Z"
            fill="#DDEBDB"
            stroke="#1E1E1E"
            strokeWidth="0.955645"
          />
          <rect
            x="72.502"
            y="20.4174"
            width="33.4476"
            height="33.4476"
            rx="16.7238"
            fill="white"
          />
          <rect
            x="72.502"
            y="20.4174"
            width="33.4476"
            height="33.4476"
            rx="16.7238"
            stroke="#1E1E1E"
            strokeWidth="0.955645"
          />
          <g clipPath="url(#clip0_1529_12692)">
            <path
              d="M84.8307 33.3993C83.4807 33.3909 83.2927 34.7041 83.2868 35.6929C83.281 36.6817 83.4536 38.0162 84.803 38.024C86.1523 38.0317 86.3411 36.7017 86.3469 35.711C86.3527 34.7203 86.1801 33.4065 84.8307 33.3993ZM84.79 40.6148C81.2802 40.5948 79.7098 38.2637 79.726 35.6722C79.7421 33.0807 81.3371 30.7872 84.8469 30.8085C88.3567 30.8298 89.9265 33.1402 89.911 35.7317C89.8955 38.3232 88.2979 40.6355 84.79 40.6148Z"
              fill="#0071B7"
            />
            <path
              d="M93.6727 33.399C92.3233 33.3912 92.1359 34.7038 92.1301 35.6938C92.1243 36.6839 92.2962 38.0159 93.6462 38.0243C94.9962 38.0327 95.183 36.7014 95.1888 35.7113C95.1946 34.7212 95.0221 33.4061 93.6727 33.399ZM93.6307 40.6158C90.1222 40.5944 88.5517 38.2634 88.5673 35.6725C88.5828 33.0817 90.179 30.7868 93.6876 30.8081C97.1961 30.8295 98.7672 33.1411 98.7523 35.732C98.7374 38.3228 97.1399 40.6351 93.6307 40.6158Z"
              fill="#0071B7"
            />
            <path
              d="M81.0593 40.6157C83.5887 41.746 86.2145 42.2482 89.0729 42.2643C92.0773 42.2818 94.356 41.7144 97.2409 40.6157L97.2241 43.7287C94.6391 45.009 91.8427 45.6998 89.0522 45.6837C86.0148 45.6656 83.8175 45.0413 81.0386 43.7287L81.0593 40.6157Z"
              fill="#0071B7"
            />
          </g>
        </g>
        <defs>
          <clipPath id="clip0_1529_12692">
            <rect
              width="19"
              height="19"
              fill="white"
              transform="translate(79.7258 27.6412)"
            />
          </clipPath>
        </defs>
      </SvgIcon>
    );
  })
);
